<mat-nav-list [ngClass]="{ 'side-nav-container': true }" fxLayout="column" fxLayoutAlign="space-between center">
  <!-- HEADER -->
  <div *ngIf="currentMenu === 'main'" class="logo-icons-container" fxLayout="row">
    <div class="logo-container">
      <img
        alt="smartOp"
        (click)="navigateToHome()"
        class="pointer logo"
        [src]="'assets/images/logos/smartop-logo-dark.svg'"
      />
    </div>
    <div class="header-icons-container">
      <div class="icons-container" fxLayout="row">
        <mat-icon
          [matTooltipDisabled]="true"
          matTooltipPosition="right"
          [matTooltip]="'Messagerie'"
          [matTooltipClass]="{ 'tooltip-menu': true }"
          (click)="navigateToMessages($event)"
          [ngClass]="{ 'current-page': '/about' === currentPage }"
        >
          chat_bubble
        </mat-icon>
        <div *ngIf="unseenMessages" class="head-badge" fxLayout="row" fxLayoutAlign="center center">
          <p>{{ unseenMessages }}</p>
        </div>
      </div>

      <div class="icons-container" fxLayout="row">
        <mat-icon
          [matTooltipDisabled]="true"
          matTooltipPosition="right"
          [matTooltip]="'Notifications'"
          [matTooltipClass]="{ 'tooltip-menu': true }"
          (click)="navigateToNotifications($event)"
          [ngClass]="{ 'current-page': '/about' === currentPage }"
        >
          notifications
        </mat-icon>
        <div *ngIf="notificationsCounter" class="head-badge" fxLayout="row" fxLayoutAlign="center center">
          <p>{{ notificationsCounter }}</p>
        </div>
      </div>

      <mat-icon
        [matTooltipDisabled]="true"
        matTooltipPosition="right"
        [matTooltip]="'Déconnexion'"
        [matTooltipClass]="{ 'tooltip-menu': true }"
        (click)="checkSaveBeforeLogout()"
      >
        logout
      </mat-icon>
    </div>
  </div>

  <div *ngIf="currentMenu === 'config'" class="config-container" fxLayout="column">
    <div (click)="navigateToHome()" class="mg-b-12 return" fxLayout="row">
      <mat-icon> arrow_back </mat-icon>
      <span class="return-text"> Retour </span>
    </div>
  </div>

  <div class="head">
    <div (click)="goToMyAccount()" class="head-profile">
      <div class="profile-image">
        <img (error)="onAvatarErrorComponent()" [src]="currentUserImage" alt="avatar" class="image" />
      </div>
      <div class="profile-info">
        <p class="name">{{ currentUserName }}</p>
        <p class="position">{{ currentUser?.profile?.position ?? '' }}</p>
      </div>
    </div>

    <div>
      <div class="select-container" *ngIf="isMultiHospitals">
        <mat-select
          *ngIf="!soloHospitalMode"
          class="hospital-select"
          [(ngModel)]="selectedHospitals"
          [compareWith]="compareCategoryObjects"
          (ngModelChange)="onChangeHospital($event)"
          multiple
          placeholder="Hôpitaux"
        >
          <mat-option
            *ngFor="let hospital of hospitals"
            [value]="hospital"
            [disabled]="nbSelectedHospitals === 1 && hospital.selected === true"
            class="hospital-mat-option"
          >
            {{ hospital.displayName }}
          </mat-option>
        </mat-select>
        <mat-select
          *ngIf="soloHospitalMode"
          class="hospital-select"
          [ngModel]="selectedHospitals"
          [compareWith]="compareCategoryObjects"
          (ngModelChange)="onChangeHospital($event)"
          placeholder="Hôpitaux"
          hideSingleSelectionIndicator
        >
          <mat-option *ngFor="let hospital of hospitals" [value]="hospital" class="hospital-mat-option">
            {{ hospital.displayName }}
          </mat-option>
        </mat-select>
      </div>

      <div (mousedown)="openProfileSearch()" class="select-container" style="width: 100%">
        <app-search-bar [placeholder]="'Rechercher un profil'"> </app-search-bar>
      </div>
    </div>
  </div>

  <div class="separator"></div>

  <!-- CONTENT -->
  <overlay-scrollbars fxFlex [options]="osComponentOptions" class="first-nav-list" #overlayScrollBar>
    <div class="nav-pages-container">
      <mat-list-item
        *ngIf="homePage && currentMenu === 'main'"
        [routerLink]="['/pending-requests/home']"
        routerLinkActive="current-page"
        [routerLinkActiveOptions]="{ exact: true }"
        class="menu-item logout-item"
        [matTooltipDisabled]="true"
        matTooltipPosition="right"
        [matTooltip]="homePage.section"
        [matTooltipClass]="{ 'tooltip-menu': true }"
        (click)="navigateToHome()"
      >
        <mat-icon class="special-menus" style="margin-bottom: 1px"> home </mat-icon>
        <span style="margin-bottom: 2px">{{ homePage.section }}</span>
      </mat-list-item>

      <div>
        <mat-accordion *ngIf="currentMenu === 'main' && initDone; else configuration">
          <mat-expansion-panel
            #panel
            *ngFor="let page of pages"
            [ngClass]="{ 'header-expanded': isMenuActive(page) }"
            class="nav-panel"
            [expanded]="isMenuActive(page)"
            [hideToggle]="!displaySubMenus(page)"
          >
            <mat-expansion-panel-header
              *ngIf="getAuthorizedPage(page.items) as authorizedPage"
              (click)="onSideNavRootItemClick(page, $event, isMenuActive(page))"
              [collapsedHeight]="'48px'"
              [expandedHeight]="'48px'"
              routerLinkActive="current-page"
              [routerLinkActiveOptions]="{
                exact: currentPage === 'besoinsgarde' ? false : true,
              }"
            >
              <mat-panel-title fxLayout="row" fxLayoutAlign="start center">
                <mat-icon *ngIf="displaySubMenus(page)" class="custom-arrow" [ngClass]="{ expanded: panel.expanded }">
                  arrow_drop_down
                </mat-icon>

                <div class="sidenav-element-text">
                  <a
                    *ngIf="!displaySubMenus(page)"
                    [routerLink]="dynamicPages.includes(authorizedPage.link) ? null : authorizedPage.link"
                    routerLinkActive="current-page"
                    [ngClass]="{
                      'current-page':
                        ((authorizedPage.link.includes('simpledayneeds') ||
                          authorizedPage.link.includes('besoinsgarde')) &&
                          isBesoinsGarde()) ||
                        (dynamicPages.includes(authorizedPage.link) && isPageActive(authorizedPage.link)),
                    }"
                    #rla="routerLinkActive"
                    class="full-header-link"
                    (click)="
                      dynamicPages.includes(authorizedPage.link)
                        ? itemSubMenuClickedHandler($event, authorizedPage)
                        : null
                    "
                  >
                    <span fxLayout="row" fxLayoutAlign="start center" [ngClass]="{ 'current-page': rla.isActive }">
                      <mat-icon>
                        {{ authorizedPage.icon.default }}
                      </mat-icon>
                      {{ authorizedPage.pageTitle }}
                    </span>
                  </a>
                  <span class="line-height-20px" *ngIf="displaySubMenus(page)">
                    {{ authorizedPage.pageTitle }}
                  </span>
                </div>
              </mat-panel-title>
              <div
                *ngIf="authorizedPage.pageTitle === sectionRequestsCounter && requestsCounter"
                class="request-counter"
              ></div>

              <div
                *ngIf="authorizedPage.pageTitle === sectionSurgeonRequestsCounter && surgeonRequestsCounter"
                class="request-counter"
              ></div>
            </mat-expansion-panel-header>

            <ng-container *ngIf="displaySubMenus(page)">
              <div class="submenu-container">
                <ng-container *ngFor="let subMenu of page.subMenus">
                  <ng-container *ngFor="let pageSub of subMenu.items">
                    <a
                      [routerLink]="dynamicPages.includes(pageSub.link) ? null : pageSub.link"
                      routerLinkActive="current-page"
                      [routerLinkActiveOptions]="{
                        exact:
                          currentPage === '/smart-planning' ||
                          currentPage === 'hrsuite/demande-rh' ||
                          currentPage === 'liste' ||
                          currentPage === 'operatingschedule' ||
                          currentPage === 'besoinsgarde' ||
                          currentPage === 'tableau-competences'
                            ? false
                            : true,
                      }"
                      #rla="routerLinkActive"
                      (click)="itemSubMenuClickedHandler($event, pageSub)"
                      *ngIf="isAllowToAccessToItem(pageSub)"
                    >
                      <span
                        class="submenu-item"
                        [ngClass]="{ 'current-page': isSubMenuActive(pageSub.link, rla.isActive) }"
                      >
                        <mat-icon>
                          {{ pageSub.icon.default }}
                        </mat-icon>
                        {{ pageSub.pageTitle }}
                        <div
                          *ngIf="pageSub.pageTitle === pageTitleRequestsCounter && requestsCounter"
                          class="request-counter request-counter-detail"
                        >
                          <span class="request-number">{{ requestsCounter }}</span>
                        </div>
                        <div
                          *ngIf="pageSub.pageTitle === pageTitleSurgeonRequestsCounter && surgeonRequestsCounter"
                          class="request-counter request-counter-detail"
                        >
                          <span class="request-number">{{ surgeonRequestsCounter }}</span>
                        </div>
                      </span>
                    </a>
                  </ng-container>
                </ng-container>
              </div>
            </ng-container>
          </mat-expansion-panel>
        </mat-accordion>

        <ng-template #configuration>
          <mat-accordion *ngIf="initDone">
            <mat-expansion-panel
              #panel
              *ngFor="let page of pagesConfig; let first = index"
              [ngClass]="{ 'header-expanded': isMenuActive(page) }"
              class="nav-panel"
              [expanded]="isMenuActive(page)"
              [hideToggle]="!displaySubMenus(page)"
            >
              <mat-expansion-panel-header
                (click)="onSideNavRootItemClick(page, $event, isMenuActive(page))"
                [collapsedHeight]="'48px'"
                [expandedHeight]="'48px'"
                routerLinkActive="current-page"
                [routerLinkActiveOptions]="{ exact: true }"
                [class.current-page2]="isMenuActive(page) && !displaySubMenus(page)"
              >
                <mat-panel-title
                  fxLayout="row"
                  fxLayoutAlign="start center"
                  *ngIf="getAuthorizedPage(page.items) as authorizedPage"
                >
                  <mat-icon *ngIf="displaySubMenus(page)" class="custom-arrow" [ngClass]="{ expanded: panel.expanded }">
                    arrow_drop_down
                  </mat-icon>
                  <div class="sidenav-element-text">
                    <a
                      *ngIf="!displaySubMenus(page)"
                      [routerLink]="authorizedPage.link"
                      routerLinkActive="current-page"
                      #rla="routerLinkActive"
                      class="full-header-link"
                    >
                      <span fxLayout="row" fxLayoutAlign="start center" [ngClass]="{ 'current-page': rla.isActive }">
                        <mat-icon>
                          {{ authorizedPage.icon.default }}
                        </mat-icon>
                        {{ authorizedPage.pageTitle }}
                      </span>
                    </a>
                    <span class="line-height-20px" *ngIf="displaySubMenus(page)">
                      {{ authorizedPage.pageTitle }}
                    </span>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <ng-container *ngIf="displaySubMenus(page)">
                <div class="submenu-container">
                  <ng-container *ngFor="let subMenu of page.subMenus">
                    <ng-container *ngFor="let pageSub of subMenu.items">
                      <a
                        [routerLink]="dynamicPages.includes(pageSub.link) ? null : pageSub.link"
                        routerLinkActive="current-page"
                        #rla="routerLinkActive"
                        (click)="itemSubMenuClickedHandler($event, pageSub)"
                        *ngIf="isAllowToAccessToItem(pageSub) && !isFichePosteItem(pageSub)"
                      >
                        <span class="submenu-item" [ngClass]="{ 'current-page': rla.isActive }">
                          <mat-icon>
                            {{ pageSub.icon.default }}
                          </mat-icon>
                          {{ pageSub.pageTitle }}
                        </span>
                      </a>

                      <a
                        [routerLink]="dynamicPages.includes(pageSub.link) ? null : pageSub.link"
                        (click)="itemSubMenuClickedHandler($event, pageSub)"
                        *ngIf="isAllowToAccessToItem(pageSub) && isFichePosteItem(pageSub)"
                        [class.current-page]="
                          pageSub.link.includes('individual') ? isFichePosteIndividualActive() : isFichePosteActive()
                        "
                      >
                        <span
                          class="submenu-item"
                          [ngClass]="{
                            'current-page': pageSub.link.includes('individual')
                              ? isFichePosteIndividualActive()
                              : isFichePosteActive(),
                          }"
                        >
                          <mat-icon>
                            {{ pageSub.icon.default }}
                          </mat-icon>
                          {{ pageSub.pageTitle }}
                        </span>
                      </a>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>
            </mat-expansion-panel>
          </mat-accordion>
        </ng-template>
      </div>
    </div>
  </overlay-scrollbars>

  <!-- FOOTER -->
  <div class="footer-container">
    <div class="sidenav-hospital-logo-container">
      <img
        class="sidenav-hospital-logo"
        [src]="
          (soloHospitalMode ? selectedHospitals?.logoUrl : selectedHospitals?.[0]?.logoUrl) || hospitals[0]?.logoUrl
        "
      />
    </div>
    <div class="config-slot">
      <mat-list-item
        *ngIf="currentMenu === 'main' && pagesConfig.length > 0"
        [routerLink]="['/configuration']"
        routerLinkActive="current-page"
        class="menu-item logout-item"
        [matTooltipDisabled]="true"
        matTooltipPosition="right"
        [matTooltip]="'Configuration'"
        [matTooltipClass]="{ 'tooltip-menu': true }"
        (click)="goToConfiguration()"
      >
        <mat-icon class="material-icons" style="margin-bottom: 2px"> settings </mat-icon>
        <span class="logout-text" style="margin-bottom: 2px">CONFIGURATION</span>
      </mat-list-item>
    </div>
  </div>
</mat-nav-list>

<div class="rightClickMenu" #rightClickMenu>
  <div *ngIf="rightClickedPage" tabindex="-1" #rightClickBtnContainer (blur)="closeRightClickedMenu()">
    <div class="menu-item" (click)="openNewTab()">Ouvrir dans un nouvel onglet</div>
    <div class="menu-item" (click)="openNewWindow()">Ouvrir dans une nouvelle fenêtre</div>
  </div>
</div>
